import Type from "@/model/types/Type";

const type = {
    TYPE_1: 1,
    TYPE_2: 2,
    TYPE_3: 3,
    TYPE_4: 4,
    TYPE_5: 5,
}

const list = [
    {
        value: type.TYPE_1,
        text: "1 - Sem tendência de piorar",
    },
    {
        value: type.TYPE_2,
        text: "2 - Piorar em longo prazo",
    },
    {
        value: type.TYPE_3,
        text: "3 - Piorar em médio prazo",
    },
    {
        value: type.TYPE_4,
        text: "4 - Piorar em curto prazo",
    },
    {
        value: type.TYPE_5,
        text: "5 - Agravar rápido",
    },
]

const contains = function (typeInput) {
    return Type.contains(list, typeInput)
}

export default {
    type,
    list,
    contains,
}